import { Injectable } from '@angular/core';

@Injectable()
export class SearchService {
	findMatchingNames(items, search, param = 'name') {
		return items.filter(item => {
			const itemName = item[param].toLowerCase();
			return itemName.includes(search.toLowerCase());
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/helpers/search.service.ts